module.exports = __webpack_public_path__ + "static/media/angrypi.e3fd4a94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/angrypi/angrypi.jpg
// module id = 823
// module chunks = 0